import { render, staticRenderFns } from "../views/app.html?vue&type=template&id=0babfb86&"
import script from "../scripts/app.ts?vue&type=script&lang=ts&"
export * from "../scripts/app.ts?vue&type=script&lang=ts&"
import style0 from "./app.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!/home/ujjwal/projects/opensource/idbstudio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VContent } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VApp,VContainer,VContent,VFlex,VLayout})


/* hot reload */
if (module.hot) {
  var api = require("/home/ujjwal/projects/opensource/idbstudio/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0babfb86', component.options)
    } else {
      api.reload('0babfb86', component.options)
    }
    module.hot.accept("../views/app.html?vue&type=template&id=0babfb86&", function () {
      api.rerender('0babfb86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/component/app.vue"
export default component.exports